import { Outlet } from 'react-router-dom'

import { BlankSlate } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import { useIsBecome } from 'modules/core/lib/useIsBecome'

import CollectionsBootstrap from 'modules/engagement_surveys/lib/MysurveysCollectionsBootstrap'

const RootPage = () => {
  const isBecome = useIsBecome()

  return (
    <CollectionsBootstrap>
      {isBecome ? (
        <BlankSlate
          illustration="alert"
          title={i18n.t('surveys.my_surveys.become_access_title')}
          description={i18n.t('surveys.my_surveys.become_access_description')}
        />
      ) : (
        <Outlet />
      )}
    </CollectionsBootstrap>
  )
}

export default RootPage
